module.exports = __webpack_public_path__ + "img/2023_LTI_PollResult.ade8abf4.png";